import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { UserLoginComponent } from './ui/user-login/user-login.component';
import { HomePageComponent } from './ui/home-page/home-page.component';
import { AuthGuard } from './core/auth.guard';
import { RoadbooksPageComponent } from './ui/roadbooks-page/roadbooks-page.component';
import { UsersPageComponent } from './ui/users-page/users-page.component';
import { UsersDetailPageComponent } from './ui/users-detail-page/users-detail-page.component';
import { ConfigPageComponent } from './ui/config-page/config-page.component';
import { ClientsPageComponent } from './ui/clients-page/clients-page.component';
import { NotificationsPageComponent } from './ui/notifications-page/notifications-page.component';
import { PrivacyPageComponent } from './ui/privacy-page/privacy-page.component';

const routes: Routes = [
  { path: 'login', component: UserLoginComponent },
  { path: 'privacy', component: PrivacyPageComponent },
  { path: '', component: HomePageComponent, canActivate: [AuthGuard] },
  { path: 'home', component: HomePageComponent, canActivate: [AuthGuard] },
  { path: 'roadbooks', component: RoadbooksPageComponent, canActivate: [AuthGuard] },
  { path: 'users', component: UsersPageComponent, canActivate: [AuthGuard] },
  { path: 'config', component: ConfigPageComponent, canActivate: [AuthGuard] },
  { path: 'clients', component: ClientsPageComponent, canActivate: [AuthGuard] },
  { path: 'notifications', component: NotificationsPageComponent, canActivate: [AuthGuard] },
  { path: 'users/:id', component: UsersDetailPageComponent, canActivate: [AuthGuard] },
  { path: '**', pathMatch: 'full', redirectTo: 'home', canActivate: [AuthGuard] }];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
